import { Component, Input, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../e-met/services/shared.service';

interface AccordionData {
  [key:string]: any;
  priceObject :{
    cadID: number
  }

}

@Component({
    selector: 'app-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
    @Input() accordionData: AccordionData[];
    @Input() applicationId: number = null;
    bff : string;
    applicationFormArray = new FormArray([]);
    constructor(private sharedService: SharedService) {
      this.bff = environment.bff;
    }

    ngOnChanges(changes : SimpleChanges): void{
      if(this.accordionData?.length){
        this.handleFormArrayGeneration(this.accordionData);
      }
    }

    handleFormArrayGeneration(data : AccordionData[]): void{
      this.applicationFormArray.clear();
      data.forEach(item => {
        const fg = new FormGroup({
          cadOfficeId : new FormControl(item.priceObject.cadID),
          buyerTaxId : new FormControl(null , Validators.required),
          paymentMethod: new FormControl(null , Validators.required)
        });
        this.applicationFormArray.push(fg)
      })
      this.applicationFormArray.valueChanges.subscribe({
        next : ()=> {
          console.log(this.applicationFormArray.valid)
          console.log(this.applicationFormArray.value)
          this.sharedService.updateCanSubmitValue(this.applicationFormArray.valid)
          this.sharedService.submissionDataSubject.next(this.applicationFormArray.value)
        }
      })
    }
}

